"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotesListing = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_redux_1 = require("react-redux");
const rebass_1 = require("rebass");
const InfiniteTable_1 = require("../../components/InfiniteTable");
const NotesRedux_1 = require("../../Redux/ActionsReducers/NotesRedux");
const AdaptableContext_1 = require("../AdaptableContext");
const AdaptableButton_1 = require("../Components/AdaptableButton");
const tableDOMProps = {
    style: {
        height: '100%',
        minWidth: '10rem',
        minHeight: 600,
    },
};
const NotesListing = () => {
    const adaptable = (0, AdaptableContext_1.useAdaptable)();
    const primaryKeyHeader = adaptable.api.columnApi.getFriendlyNameForColumnId(adaptable.api.columnApi.getPrimaryKeyColumn().columnId);
    const allNotes = (0, react_redux_1.useSelector)((state) => (0, NotesRedux_1.GetNotesSelector)(state.Notes));
    const columnsMap = React.useMemo(() => {
        const columns = {
            primaryKey: {
                field: 'PrimaryKeyValue',
                header: primaryKeyHeader,
            },
            column: {
                field: 'ColumnId',
                valueGetter: (params) => {
                    return adaptable.api.columnApi.getFriendlyNameForColumnId(params.data.ColumnId);
                },
            },
            note: {
                field: 'Value',
                header: 'Note',
                defaultEditable: true,
                defaultFlex: 3,
            },
            timestamp: {
                field: 'Timestamp',
                valueGetter: (params) => {
                    return new Date(params.data.Timestamp).toDateString();
                },
            },
            author: {
                header: 'Author',
                valueGetter: (params) => params.data.Author.UserName,
            },
            delete: {
                defaultWidth: 50,
                render: (params) => {
                    return (React.createElement(AdaptableButton_1.AdaptableButtonComponent, { variant: "text", icon: "delete", onClick: () => {
                            const note = adaptable.api.notesApi.getNoteByUuid(params.data.Uuid);
                            adaptable.api.notesApi.deleteNote(note);
                        } }));
                },
            },
        };
        return columns;
    }, []);
    return (React.createElement(rebass_1.Box, { p: 2, style: { height: '100%', width: '100%' } },
        React.createElement(InfiniteTable_1.DataSource, { data: allNotes, primaryKey: "Uuid", onDataMutations: (params) => {
                for (const mutation of params.mutations) {
                    const [uuid, changes] = mutation;
                    for (const change of changes) {
                        if (change.type === 'update') {
                            const data = change.data;
                            const prevNote = allNotes.find((x) => x.Uuid === uuid);
                            if (prevNote.Value !== data.Value) {
                                adaptable.api.notesApi.updateNoteText(data.Value, prevNote);
                            }
                        }
                    }
                }
            } },
            React.createElement(InfiniteTable_1.InfiniteTable, { columnTypes: {
                    default: {
                        align: 'start',
                        defaultFlex: 1,
                        sortable: false,
                    },
                }, headerOptions: {
                    alwaysReserveSpaceForSortIcon: false,
                }, rowHeight: 40, columnHeaderHeight: 65, domProps: tableDOMProps, columns: columnsMap }))));
};
exports.NotesListing = NotesListing;
